import { SavingsInfo } from "./SavingsInfo";
import { Stats } from "./Stats";
import { DiffBenchmark } from "./DiffBenchmark";
import { OffersData } from "./OffersData";

export class PackageData {
    offers: OffersData[];
    startDate: Date;
    price: number | null;
    isMaxTheSavings: boolean | null;
    isBuyTheDip: boolean | null;
    isPlayItShort: boolean | null;
    isNewby: boolean | null;
    savings: { [id in DiffBenchmark]: SavingsInfo };
    priceStats: Stats | null;
}